import ContactShow from "../components/contact/index.vue";

export default [
  { name: 'Contact', path: '/contact', component: ContactShow,  }
]
